import { UseBaseMutationOptions } from '@/core/api/type'
import { useMutation } from '@tanstack/react-query'
import { PartnerMutationKeys } from '../../../../manage-player/keys'
import {
	CreatePartnerRequest,
	CreatePartnerResponse,
} from '../../../../manage-player/type'
import { createPartner } from '../../../../manage-player/api/services'

interface UseMutationCreatePartnerProps {
	payload: CreatePartnerRequest
}

export default function useMutationCreatePartner(
	props?: UseBaseMutationOptions<
		CreatePartnerResponse,
		UseMutationCreatePartnerProps
	>,
) {
	return useMutation({
		mutationKey: [PartnerMutationKeys.CreatePartner],
		mutationFn: (params) => createPartner(params.payload),
		...props,
	})
}
